export { Icon } from './Icon';
export type { IconName, IconProps } from './Icon';
